<template>
  <WebsiteCmsShell
    class="website-post-page"
    :title="'Berita ' + clinic_name"
    subtitle="Tulis dan kelola informasi kesehatan, kegiatan, serta kabar terbaru klinik"
    action-label="Tulis Berita"
    list-eyebrow="Publikasi website"
    list-title="Daftar berita"
    list-description="Kelola artikel, jadwal publikasi, kategori, dan status tayang."
    @action="$router.push('/website/posts/add')"
  >
    <template #list><Table purpose="master" /></template>
  </WebsiteCmsShell>
</template>

<script>
import WebsiteCmsShell from "@/component/websites/WebsiteCmsShell.vue";
import Form from "@/component/websites/PostForm.vue";
import FormEdit from "@/component/websites/PostFormEdit.vue";
import FormDetail from "@/component/websites/PostFormDetail.vue";
import Table from "@/component/websites/PostTable.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "website-post",
  data() {
    return {
      form: {
        title: "",
        excerpt: "",
        content: "",
        date: window.medhopToday(),
        author: "",
        tags: "",
        post_category_id: '',
        image: "",
        status: "",
        yt_link:"",
      },
      FormEditActv: false,
      FormDetailActv: false,
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    };
  },
  components: {
    WebsiteCmsShell,
    Table,
    Form,
    FormEdit,
    FormDetail,
  },
  methods:{
    resetFormOnNew(){
      // reset form on new (tambah data)
      var self = this;
      Object.keys(this.form).forEach(function (key, index) {
        if (key === "image") {
          self.form[key] = [];
        } else if(key === "_method"){
          self.form[key] = "post"
        } else {
          self.form[key] = "";
        }
      });
    },

    scrollToElement(options) {
      let el = this.$el.getElementsByClassName("website-cms-editor-anchor")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew()
      }
    },

    scrollToTop(options) {
      // window.scrollTo(0, 0);
       let el = this.$el;
      // el = el ?? this.$el.getElementsByClassName("table-setting")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew()
      }
    },

    btnAddOnClick(){
      this.FormEditActv = false
      this.FormDetailActv = false
      this.scrollToElement({ behavior: 'smooth' })
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Website", route: "" },
      { title: "CMS", route: "" },
      { title: "Post", route: "" },
    ]);

    // Scroll ToTop
    this.$root.$on("scrollToTop", () => {
      // reset form on new (tambah data)
      this.resetFormOnNew()
    });

    // Add Website Post
    this.$root.$on("updateWebsitePost", () => {
      // reset form on new (tambah data)
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });

      // Cancel Add Website Post
    this.$root.$on("cancelAddWebsitePost", () => {
      // reset form on new (tambah data)
      this.scrollToTop({ behavior: "smooth" });
      this.resetFormOnNew();
    });

    //  Edit Website Post
    this.$root.$on("getWebsitePostById", (data) => {
      this.FormDetailActv = false
      this.FormEditActv = true
     this.scrollToElement({ behavior: 'smooth' })

      if(data.status == 0){
        data.status = false
      }else if(data.status == 1){
        data.status = true
      }

     this.form = data
     this.form['_method'] = 'put'
    });

    // Cancel Edit
    this.$root.$on("cancelWebsitePostUpdate", () => {
      this.FormEditActv = false
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });

    // Detail Web Post
    this.$root.$on("getWebsitePostByIdDetail", (data) => {
      this.FormDetailActv = true
      this.FormEditActv = false
     this.scrollToElement({ behavior: 'smooth' })

      if(data.status == 0){
        data.status = false
      }else if(data.status == 1){
        data.status = true
      }
     this.form = data
    });
  },
};
</script>
